<template>
  <div class="wrap">
    <h3>为什么需要输入身份证</h3>
    <ul>
      <li>
          1、233小游戏的身份证信息验证是绝对安全的。我们是使用阿里云平台的信息安全验证，完全符合国家安全法律法规的要求，绝对不会窃取用户个人信息，也不会将用户个人信息用于其他任何用途。
      </li>
      <li>
          2、233小游戏是会保证您的提现信息安全的，提供的身份证号我们会通过微信和支付宝的安全验证，保证您提现信息一致，再将钱汇入您提供的账户中。
      </li>
      <li>
          3、我们获取您的身份证号码，目的是依据国家法律规定缴纳提现产生的个人所得税。我们将确保信息安全，也不会将身份证信息用于其他任何用途。
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .wrap{
    width: 100%;
    padding: 10px;
  }
  h3{
    margin: 10px;
    font-weight: 900;
  }
  ul{
    margin: 10px;
  }
  ul li{
    line-height: 30px;
    margin-bottom: 10px;
  }

</style>
